import type { AuditLogEntry } from '@rossum/api-client/auditLogs';
import type { ActivityRow, ActivityRowContext } from '../../core';
import { findClosedAt, isSessionStart } from './reviewingSession';

export const toOpenedRows = (
  entry: AuditLogEntry,
  context: ActivityRowContext
): ActivityRow[] =>
  isSessionStart(entry, context)
    ? [
        {
          kind: 'opened',
          key: `${entry.timestamp}:opened`,
          openedAt: entry.timestamp,
          closedAt: findClosedAt(context),
        },
      ]
    : [];
